// mutation types
export const SET_MODAL_STATE = "setModalState";
export const HIDE_MODAL = "hideModal";
export const SET_MODAL_HEIGHT = "setModalHeight";

const state = {
  showModal: false,
  modalName: null,
  modalData: {},
  modalHeight: 0
};

const getters = {
  showModal(state) {
    return state.showModal;
  }
};

const actions = {};

const mutations = {
  [SET_MODAL_STATE](state, { show, modalName, modalData }) {
    state.showModal = show;
    state.modalName = modalName;
    state.modalData = modalData;
  },

  [HIDE_MODAL](state) {
    state.showModal = false;
    state.modalName = null;
    state.modalData = {};
  },
  [SET_MODAL_HEIGHT](state, height) {
    state.modalHeight = height;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
